import React from 'react';
import { Card, Tooltip, Form, Input, Checkbox, Button } from 'antd';
import { QuestionOutlined, WarningOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { formConfig, GlobalSettingFormItem } from './constants';
import { GlobalSettings } from '@services/types';
import styles from './global-settings.module.scss';
import { AppContext } from '@layouts/AppRouter';

const { TextArea } = Input;

const InputTooltip = ({ item }: { item: GlobalSettingFormItem }) => {
  return (
    <div>
      <strong>{item?.description?.header}</strong>
      <ul>
        {item?.description?.rules.map((rule) => {
          return <li key={rule}>{rule}</li>;
        })}
      </ul>
    </div>
  );
};

const GlobalSettingPage: React.FC = () => {
  const [form] = Form.useForm<GlobalSettings>();
  const { settings, updateGlobalSettings } = React.useContext(AppContext);
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await updateGlobalSettings(values);
      toast.success('Global settings was updated');
    } catch (error) {
      toast.error('Global settings was not updated');
      console.log('GlobalSetting ~ handleSubmit ~ error', error);
    }
  };

  React.useEffect(() => {
    if (settings) {
      form.setFieldsValue(settings);
    }
  }, [form, settings]);

  return (
    <div className={styles.main}>
      <Form form={form} className={styles.wrapper} onFinish={handleSubmit} layout="vertical">
        {Object.values(formConfig).map((item, i) => (
          <Card
            headStyle={{ fontSize: '22px' }}
            className={styles.card}
            key={i}
            title={item.label}
            extra={
              <Tooltip
                placement="rightTop"
                title={item.label !== 'Jobs' ? item?.tooltip : <InputTooltip item={item} />}
              >
                {item.label === 'Jobs' ? <WarningOutlined /> : <QuestionOutlined />}
              </Tooltip>
            }
          >
            {item.values.map((el: any) =>
              el?.type !== 'boolean' ? (
                <Form.Item
                  key={el.field}
                  name={el?.field}
                  className={styles.inputBlock}
                  tooltip={<InputTooltip item={el} />}
                  label={el.label}
                  style={{ gridArea: el?.field }}
                >
                  {el?.type === 'number' ? (
                    <Input type={el?.type} min={el?.value?.min || 0} max={el?.value?.max || 256} />
                  ) : el.field === 'authLockMessage' ? (
                    <TextArea maxLength={el?.value?.max || 500} rows={4} />
                  ) : (
                    <Input type={el?.type} minLength={el?.value?.min || 0} maxLength={el?.value?.max || 256} />
                  )}
                </Form.Item>
              ) : (
                <Form.Item
                  key={el.field}
                  name={el?.field}
                  className={styles.inputBlock}
                  tooltip={<InputTooltip item={el} />}
                  label={el.label}
                  valuePropName={'checked'}
                  style={{ gridArea: el?.field }}
                >
                  <Checkbox />
                </Form.Item>
              ),
            )}
          </Card>
        ))}
        <Form.Item className={styles.submit}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default React.memo(GlobalSettingPage);
